import React from 'react';
import BaseProps from "../../../types/BaseProps";
import SelectMenu, {OptionProps} from "../../../components/select/SelectMenu";

type PageSizeSelectorProps = {
  onPageSizeChange: (size: number) => void;
  disabled: boolean
};

type PageSizeSelectorState = {
  options: Array<OptionProps>;
  selected: string;
}

/**
 * Component allowing page size selection.
 */
class PageSizeSelector extends React.Component<PageSizeSelectorProps & BaseProps, PageSizeSelectorState> {

  private readonly DEFAULT_PAGE_SIZE: string = '10';

  constructor(props: any) {
    super(props);
    const options: Array<OptionProps> = ['10', '20', '50'].map(key => {
      return {
        id: key,
        label: key
      };
    });
    this.state = {
      selected: this.DEFAULT_PAGE_SIZE,
      options
    };
  }

  onPageSizeChange = (selected: string) => {
    this.setState({selected});
    this.props.onPageSizeChange(parseInt(selected))
  };

  render() {
    return (
      <div className="ToolItem PageSizeSelector">
        <SelectMenu options={this.state.options}
                    selected={this.state.selected}
                    onChange={this.onPageSizeChange}
                    standalone={false}
                    disabled={this.props.disabled}
        />
      </div>
    );
  }
}

export default PageSizeSelector;
